import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';

const CustomAngleAxisTick = ({ x, y, payload }) => {
  const value = payload?.value ? String(payload.value) : '';
  const words = value.split(' ');
  return (
    <g transform={`translate(${x},${y})`}>
      <text textAnchor="middle" className="fill-foreground text-[13px] font-semibold">
        {words.map((word, i) => (
          <tspan x={0} dy={i > 0 ? '1.2em' : 0} key={i}>
            {word}
          </tspan>
        ))}
      </text>
    </g>
  );
};

export default function SkillsRadarChart({ data }) {
  return (
    <div className="flex w-full min-h-[360px] flex-col items-center justify-center">
      <h3 className="mb-4 shrink-0 text-center text-lg font-bold text-primary">Skills distribution</h3>
      <div className="flex h-[320px] w-full max-w-[350px] items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart cx="50%" cy="50%" outerRadius="70%" data={data}>
            <PolarGrid className="stroke-border" />
            <PolarAngleAxis dataKey="skill" tick={<CustomAngleAxisTick />} />
            <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axisLine={false} />
            <Radar
              name="Candidate"
              dataKey="score"
              stroke="hsl(var(--primary))"
              fill="hsl(var(--primary))"
              fillOpacity={0.55}
            />
            <Tooltip
              contentStyle={{
                background: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
                color: 'hsl(var(--card-foreground))',
              }}
            />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
